import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
    statusCode: number;
    message?: string;
    data?: any;
};

export const earningsAPI = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        // Stats - /sp/payouts/stats
        getPayoutsStats: builder.query<CommonResponse, void>({
            query: () => ({
                url: END_POINTS.payoutsStats,
                method: "GET",
            }),
        }),

        // Pending tab - /sp/payouts/balance
        getPayoutsBalance: builder.query<
            CommonResponse,
            { page?: number; limit?: number; search?: string; payoutStartDate?: string; payoutEndDate?: string } | void
        >({
            query: (params) => {
                const newParams: any = { ...params };
                if (!newParams?.search) delete newParams?.search;
                if (!newParams?.page) delete newParams?.page;
                if (!newParams?.limit) delete newParams?.limit;
                if (newParams?.payoutStartDate) {
                    newParams.startDate = newParams.payoutStartDate;
                    delete newParams.payoutStartDate;
                }
                if (newParams?.payoutEndDate) {
                    newParams.endDate = newParams.payoutEndDate;
                    delete newParams.payoutEndDate;
                }
                return {
                    url: END_POINTS.payoutsBalance,
                    method: "GET",
                    params: newParams,
                };
            },
        }),

        // Completed tab - /sp/payouts/history
        getPayoutsHistory: builder.query<
            CommonResponse,
            { page?: number; limit?: number; payoutStartDate?: string; payoutEndDate?: string; search?: string; isScheduled?: boolean | number }
        >({
            query: (params) => {
                const newParams: any = { ...params };
                if (!newParams.page) delete newParams.page;
                if (!newParams.limit) delete newParams.limit;
                if (!newParams.payoutStartDate) delete newParams.payoutStartDate;
                if (!newParams.payoutEndDate) delete newParams.payoutEndDate;
                if (!newParams.search) delete newParams.search;
                if (newParams.isScheduled === undefined) delete newParams.isScheduled;
                return {
                    url: END_POINTS.payoutsHistory,
                    method: "GET",
                    params: newParams,
                };
            },
        }),

        // Payout History Tab using booking API - /sp/booking/list
        getPayoutsBookingList: builder.query<
            CommonResponse,
            { page?: number; limit?: number; payoutStartDate?: string; payoutEndDate?: string; search?: string; payoutPaid?: boolean | number; isScheduled?: boolean | number; status?: number }
        >({
            query: (params) => {
                const newParams: any = { ...params };
                if (!newParams.page) delete newParams.page;
                if (!newParams.limit) delete newParams.limit;
                if (newParams.payoutStartDate) {
                    newParams.startDate = newParams.payoutStartDate;
                }
                delete newParams.payoutStartDate;
                if (newParams.payoutEndDate) {
                    newParams.endDate = newParams.payoutEndDate;
                }
                delete newParams.payoutEndDate;
                if (!newParams.search) delete newParams.search;
                if (newParams.payoutPaid === undefined) delete newParams.payoutPaid;
                if (newParams.isScheduled === undefined) delete newParams.isScheduled;
                if (newParams.status === undefined) delete newParams.status;
                return {
                    url: END_POINTS.bookingList,
                    method: "GET",
                    params: newParams,
                };
            },
        }),

        // Payout Connect Account Status - /sp/payouts/connect/account-status
        getPayoutAccountStatus: builder.query<CommonResponse, void>({
            query: () => ({
                url: END_POINTS.payoutAccountStatus,
                method: "GET",
            }),
        }),

        // Payout Onboarding Link - /sp/payouts/connect/onboarding-link
        getPayoutOnboardingLink: builder.query<CommonResponse, any>({
            query: (body) => ({
                url: END_POINTS.payoutOnboardingLink,
                method: "POST",
                body,
            }),
        }),

        // Payout Request Information - /sp/payouts/connect/request-information
        getPayoutRequestInformation: builder.query<CommonResponse, void>({
            query: () => ({
                url: END_POINTS.payoutRequestInformation,
                method: "GET",
            }),
        }),
    }),
});

export const {
    useGetPayoutsStatsQuery,
    useGetPayoutsBalanceQuery,
    useGetPayoutsHistoryQuery,
    useGetPayoutsBookingListQuery,
    useGetPayoutAccountStatusQuery,
    useLazyGetPayoutAccountStatusQuery,
    useLazyGetPayoutOnboardingLinkQuery,
    useLazyGetPayoutRequestInformationQuery,
} = earningsAPI;

